type Props = {
  size?: number;
  color?: string;
  className?: string;
};

export const PersonIcon = ({
  size = 16,
  color = "currentColor",
  className,
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_36_25)">
        <path
          d="M29.9257 39.2771V35.5364C29.9257 33.5522 29.1375 31.6493 27.7345 30.2463C26.3315 28.8433 24.4285 28.0551 22.4444 28.0551H9.35197C7.36779 28.0551 5.46487 28.8433 4.06185 30.2463C2.65882 31.6493 1.87061 33.5522 1.87061 35.5364V39.2771"
          stroke={color}
          strokeWidth="3.74068"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8979 20.5737C20.0297 20.5737 23.3792 17.2242 23.3792 13.0923C23.3792 8.96048 20.0297 5.61096 15.8979 5.61096C11.766 5.61096 8.4165 8.96048 8.4165 13.0923C8.4165 17.2242 11.766 20.5737 15.8979 20.5737Z"
          stroke={color}
          strokeWidth="3.74068"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.7959 20.5737L35.5366 24.3144L43.0179 16.833"
          stroke={color}
          strokeWidth="3.74068"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_36_25">
          <rect width="44.8882" height="44.8882" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
